import * as React from "react";
import { $, merge } from "glamor";
import { FormatMessage } from "react-globalize";

export interface IProps {
    path: string;
}

export class FeatureDisabled extends React.PureComponent<IProps, any> {
    private styles = merge(
        $(" .featuredDisabled", {
            display: "flex",
        })
    );

    render() {
        const { path } = this.props;
        return (
            <div {...this.styles}>
                <p className="featuredDisabled">
                    <FormatMessage
                        path={path}
                        elements={{
                            link: <a href={"mailto:sales@nuorder.com"} />,
                        }}
                    />
                </p>
            </div>
        );
    }
}
